import * as cookie from 'cookie';

/**
 * 쿠키를 문자열로 직렬화합니다.
 * @description
 * - cookie.serialize를 래핑합니다.
 * @example
 * // stringifyCookie('sessionId', 'abc123')
 */
export const stringifyCookie = (
  name: string,
  value: string,
  options?: cookie.SerializeOptions,
): string => {
  return cookie.serialize(name, value, options);
};

/**
 * 여러 쿠키를 Set-Cookie 헤더 문자열 배열로 직렬화합니다.
 * @description
 * - 공통 옵션을 모든 쿠키에 적용합니다.
 * @example
 * // stringifyCookies({ sessionId: 'abc' })
 */
export const stringifyCookies = (
  cookies: Record<string, string>,
  options?: cookie.SerializeOptions,
): string[] => {
  return Object.entries(cookies).map(([name, value]) => stringifyCookie(name, value, options));
};
